import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { AccountProvider } from "@/lib/AccountContext";
import { PdfViewerProvider } from "@/lib/PdfViewerContext";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Terms from "@/pages/Terms";
import DefiArchitecture from "@/pages/DefiArchitecture";
import Business from "@/pages/Business";
import LanguageHintBanner from "@/components/LanguageHintBanner";
import EmergentBadgeControl from "@/components/EmergentBadgeControl";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import Transfers from "@/pages/dashboard/Transfers";
import Movements from "@/pages/dashboard/Movements";
import Documents from "@/pages/dashboard/Documents";
import Kyc from "@/pages/dashboard/Kyc";
import Profile from "@/pages/dashboard/Profile";
import AdminApprovals from "@/pages/dashboard/AdminApprovals";
import AdminUsers from "@/pages/dashboard/AdminUsers";
import AdminMetrics from "@/pages/dashboard/AdminMetrics";
import IbanValidator from "@/pages/dashboard/IbanValidator";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="font-mono-fin text-xs text-slate-500">Cargando...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <PdfViewerProvider>
          <Toaster position="top-right" richColors />
          <LanguageHintBanner />
          <BrowserRouter>
          <EmergentBadgeControl />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/terminos" element={<Terms />} />
            <Route path="/arquitectura-defi" element={<DefiArchitecture />} />
            <Route path="/empresas" element={<Business />} />
            <Route path="/app" element={<Protected><AccountProvider><DashboardLayout /></AccountProvider></Protected>}>
              <Route index element={<Overview />} />
              <Route path="transferencias" element={<Transfers />} />
              <Route path="movimientos" element={<Movements />} />
              <Route path="documentos" element={<Documents />} />
              <Route path="kyc" element={<Kyc />} />
              <Route path="perfil" element={<Profile />} />
              <Route path="iban-validator" element={<IbanValidator />} />
              <Route path="admin/aprobaciones" element={<AdminApprovals />} />
              <Route path="admin/usuarios" element={<AdminUsers />} />
              <Route path="admin/metricas" element={<AdminMetrics />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </PdfViewerProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
